import type {AddComponentTypeOptions} from 'grapesjs';
import {FORM_IMAGE_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_IMAGE_TYPE = 'postermywall-image';
const FORM_IMAGE_DATA_ATTR = 'data-is-pmw-form-image';

export const POSTERMYWALL_IMAGE: AddComponentTypeOptions = {
  isComponent: (el: HTMLElement) => {
    if (typeof el.getAttribute !== 'function') {
      return undefined;
    }
    return el.tagName === 'IMG' && el.getAttribute(FORM_IMAGE_DATA_ATTR) !== null ? {type: POSTERMYWALL_IMAGE_TYPE} : undefined;
  },
  model: {
    defaults: {
      tagName: 'img',
      toolbar: [],
      removable: true,
      highlightable: false,
      hoverable: false,
      selectable: false,
      badgable: false,
      attributes: {
        [FORM_IMAGE_DATA_ATTR]: '1',
        'data-pmw-type': POSTERMYWALL_IMAGE_TYPE,
        class: 'pmw-media-type',
        alt: '',
        'aria-hidden': 'true',
      },
      src: '',
      style: FORM_IMAGE_STYLES,
    },
  },
};
